module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Sahara.e788b15a.jpg";